/**
 * Context for server-side hotel ranking (hotel_priority_rules / pinned_hotels).
 * Always send hr_applies_to; send hr_destination_id only when canonical resolve succeeded.
 */
export function buildHotelSearchRankingFields(hrDestinationId, hrAppliesTo) {
  return {
    ...(hrDestinationId != null ? { hr_destination_id: hrDestinationId } : {}),
    hr_applies_to: hrAppliesTo,
  };
}
